import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'

const TABS = {
  blueprints: {
    label: 'Blueprints Adoption',
    value: 'blueprints',
    embedUrl:
      'https://app.powerbi.com/reportEmbed?reportId=05cffa6b-8e9a-41f6-878d-468bb1b0316e&autoAuth=true&ctid=33d4f3e5-3df2-421e-b92e-a63cfa680a88'
  },
  'usage-metrics': {
    label: 'Usage Metrics',
    value: 'usage-metrics',
    embedUrl:
      'https://app.powerbi.com/reportEmbed?reportId=a15f97e7-56c7-41f6-866e-5c85fff9ecaa&autoAuth=true&ctid=33d4f3e5-3df2-421e-b92e-a63cfa680a88'
  }
}

const InternalBI = () => {
  return (
    <Tabs className="w-full h-full flex flex-col" defaultValue="blueprints">
      <TabsList className={`grid w-full grid-cols-${Object.keys(TABS).length}`}>
        {Object.entries(TABS).map(([key, value]) => (
          <TabsTrigger key={key} value={key}>
            {value.label}
          </TabsTrigger>
        ))}
      </TabsList>
      {Object.entries(TABS).map(([key, value]) => (
        <TabsContent className="h-full" key={key} value={key}>
          <iframe
            allowFullScreen={true}
            height={'100%'}
            src={value.embedUrl}
            title="epilot Internal BI"
            width={'100%'}
          />
        </TabsContent>
      ))}
    </Tabs>
  )
}

export default InternalBI
